import { Action, ActionReducer, ActionReducerMap, combineReducers, createFeatureSelector, createSelector, MetaReducer } from '@ngrx/store';
import * as fromSearchEmployee from './search-employee.reducer';
import * as fromDeleteEmployees from './delete-employees.reducer';
import * as fromSelectedEmployee from './selected-employee.reducer';
import * as fromResendInvite from './resend-invite.reducer';

export const employeeSearchFeatureKey = 'employeeSearch';

export interface EmployeeSearchMainState {
  [fromSearchEmployee.searchEmployeeFeatureKey]: fromSearchEmployee.SearchEmployeeState;
  [fromDeleteEmployees.deleteEmployeesFeatureKey]: fromDeleteEmployees.DeleteEmployeesState;
  [fromSelectedEmployee.selectedEmployeeFeatureKey]: fromSelectedEmployee.SelectedEmployeeState;
  [fromResendInvite.resendInviteFeatureKey]: fromResendInvite.ResendInviteState;
}

export interface State {
  [employeeSearchFeatureKey]: EmployeeSearchMainState;
}

export function reducers(state: EmployeeSearchMainState | undefined, action: Action) {
  return combineReducers({
    [fromSearchEmployee.searchEmployeeFeatureKey]: fromSearchEmployee.reducer,
    [fromDeleteEmployees.deleteEmployeesFeatureKey]: fromDeleteEmployees.reducer,
    [fromSelectedEmployee.selectedEmployeeFeatureKey]: fromSelectedEmployee.reducer,
    [fromResendInvite.resendInviteFeatureKey]: fromResendInvite.reducer
  })(state, action);
}
